import React from 'react';

import I18n from '@app/modules/i18n';
import Illustration from '@app/component/illustration';

const Blocked = () => (
  <React.Fragment>
    <div className="transfer__contents blocked-transfer">
      <Illustration type="transfer-blocked" />
      <h2 className="blocked-transfer__title">
        {I18n.t('transfer.download.blocked.title')}
      </h2>
      <p className="blocked-transfer__description">
        {I18n.t('transfer.download.blocked.text')}
      </p>
      <a
        href="https://wetransfer.zendesk.com/hc/en-us/articles/360025459652"
        target="zendesk-blocked-transfer"
        className="blocked-transfer__reference"
      >
        {I18n.t('transfer.download.blocked.link')}
      </a>
    </div>
    <div className="transfer__footer">
      <button className="transfer__button transfer__button--inactive" disabled>
        {I18n.t('transfer.buttons.download')}
      </button>
    </div>
  </React.Fragment>
);

export default React.memo(Blocked);
